var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/statuses/sensitive-content-overlay.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import classNames from 'clsx';
import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSettings, useSoapboxConfig } from 'soapbox/hooks';
import { defaultMediaVisibility } from 'soapbox/utils/status';
import { Button, HStack, Text } from '../ui';
const messages = defineMessages({
  hide: {
    "id": "moderation_overlay.hide",
    "defaultMessage": "Hide content"
  },
  sensitiveTitle: {
    "id": "status.sensitive_warning",
    "defaultMessage": "Sensitive content"
  },
  underReviewTitle: {
    "id": "moderation_overlay.title",
    "defaultMessage": "Content Under Review"
  },
  underReviewSubtitle: {
    "id": "moderation_overlay.subtitle",
    "defaultMessage": "This Post has been sent to Moderation for review and is only visible to you. If you believe this is an error please contact Support."
  },
  sensitiveSubtitle: {
    "id": "status.sensitive_warning.subtitle",
    "defaultMessage": "This content may not be suitable for all audiences."
  },
  contact: {
    "id": "moderation_overlay.contact",
    "defaultMessage": "Contact"
  },
  show: {
    "id": "moderation_overlay.show",
    "defaultMessage": "Show Content"
  }
});
const SensitiveContentOverlay = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    onToggleVisibility,
    status
  } = props;
  const isUnderReview = status.visibility === 'self';
  const settings = useSettings();
  const displayMedia = settings.get('displayMedia');
  const intl = useIntl();
  const {
    links
  } = useSoapboxConfig();
  const [visible, setVisible] = useState(defaultMediaVisibility(status, displayMedia));

  const toggleVisibility = event => {
    event.stopPropagation();

    if (onToggleVisibility) {
      onToggleVisibility();
    } else {
      setVisible(prevValue => !prevValue);
    }
  };

  useEffect(() => {
    if (typeof props.visible !== 'undefined') {
      setVisible(!!props.visible);
    }
  }, [props.visible]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('absolute z-40', {
      'cursor-default backdrop-blur-lg rounded-lg w-full h-full border-0 flex justify-center items-center': !visible,
      'bg-gray-800/75 inset-0': !visible,
      'bottom-1 right-1': visible
    }),
    "data-testid": "sensitive-overlay",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 5
    }
  }, visible ? /*#__PURE__*/React.createElement(Button, {
    text: intl.formatMessage(messages.hide),
    icon: require('@tabler/icons/eye-off.svg'),
    onClick: toggleVisibility,
    theme: "primary",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-center w-3/4 mx-auto space-y-4",
    ref: ref,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "white",
    weight: "semibold",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 13
    }
  }, intl.formatMessage(isUnderReview ? messages.underReviewTitle : messages.sensitiveTitle)), /*#__PURE__*/React.createElement(Text, {
    theme: "white",
    size: "sm",
    weight: "medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 13
    }
  }, intl.formatMessage(isUnderReview ? messages.underReviewSubtitle : messages.sensitiveSubtitle)), status.spoiler_text && /*#__PURE__*/React.createElement("div", {
    className: "py-4 italic",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Text, {
    className: "line-clamp-6",
    theme: "white",
    size: "md",
    weight: "medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 17
    }
  }, "\u201C", /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: status.spoilerHtml
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 26
    }
  }), "\u201D"))), /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    justifyContent: "center",
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 11
    }
  }, isUnderReview ? /*#__PURE__*/React.createElement(React.Fragment, null, links.get('support') && /*#__PURE__*/React.createElement("a", {
    href: links.get('support'),
    target: "_blank",
    onClick: event => event.stopPropagation(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 19
    }
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    theme: "outline",
    size: "sm",
    icon: require('@tabler/icons/headset.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 21
    }
  }, intl.formatMessage(messages.contact)))) : null, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    theme: "outline",
    size: "sm",
    icon: require('@tabler/icons/eye.svg'),
    onClick: toggleVisibility,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 13
    }
  }, intl.formatMessage(messages.show)))));
});
export default SensitiveContentOverlay;